<div class="modal-container">
    <div class="modal-header">
        <button type="button" class="close btn-close" (mousedown)="onClose()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <div id="detail-card-container">
            <div class="detail-card-wrap">
                <div class="tabset-container" (click)="$event.preventDefault()" *ngIf="employeeDetails">
                    <tabset>
                        <tab *ngFor="let tabz of tabs;let i=index;trackBy:trackByFn1" [heading]="tabz.title"
                            [active]="tabz.active" (selectTab)="getTabData(tabz.title)" (deselect)="tabz.active = false"
                            [disabled]="tabz.disabled" [customClass]="tabz.customClass">

                            <!-- Tab Contents -->
                            <div [ngSwitch]="tabz?.content">
                                <!-- Detail Tab content -->
                                <div *ngSwitchCase="'details'">
                                    <div class="detail-tab-content-container">
                                        <div class="detail-tab-content-wrap">
                                            <weaccess-info-card [showReqName]="employeeDetails?.showRequesterName"
                                                [requesterShortName]="employeeDetails?.reqShortName"
                                                [requesterFullName]="employeeDetails?.reqFullName"
                                                [showUpdateBtn]="employeeDetails?.showUpdateButton">
                                            </weaccess-info-card>
                                        </div>
                                        <div class="detail-tab-content-wrap"
                                            *ngFor="let persondetail of employeeDetails?.personDetails;let i=index;trackBy:trackByFn2">
                                            <weaccess-info-card [cardTitle]="persondetail.InfoTitle"
                                                [cardDetails]="persondetail.InfoDetails"></weaccess-info-card>
                                        </div>
                                    </div>


                                </div>

                                <!-- History tab content -->
                                <div *ngSwitchCase="'history'">
                                    <div class="detail-tab-content-container">
                                        <div class="detail-tab-content-wrap">
                                            <div class="row m-0">
                                                <div class="col-sm-12 plr">
                                                    <h6 class="info-title mt-0">
                                                        {{globalConstants.REQUEST_EMPLOYEE_DETAILS}}</h6>
                                                </div>
                                                <div class="col-sm-12 p-0">
                                                    <weaccess-table [tableColumns]="requestTableColumns"
                                                        [tableData]="requestTableData"></weaccess-table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail-tab-content-wrap">
                                            <div class="row m-0">
                                                <div class="col-sm-12 plr">
                                                    <h6 class="info-title">
                                                        {{globalConstants.DEPARTMENT_EMPLOYEE_DETAILS}}
                                                    </h6>
                                                </div>
                                                <div class="col-sm-12 p-0">
                                                    <weaccess-table [tableColumns]="departmentTableColumns"
                                                        [tableData]="departmentTableData"></weaccess-table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail-tab-content-wrap">
                                            <div class="row m-0">
                                                <div class="col-sm-12 plr">
                                                    <h6 class="info-title">{{globalConstants.MANAGER_EMPLOYEE_DETAILS}}
                                                    </h6>
                                                </div>
                                                <div class="col-sm-12 p-0">
                                                    <weaccess-table [tableColumns]="managerTableColumns"
                                                        [tableData]="managerData"></weaccess-table>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="detail-tab-content-wrap">
                                            <div class="row m-0">
                                                <div class="col-sm-12 plr">
                                                    <h6 class="info-title">{{globalConstants.TITLE_EMPLOYEE_DETAILS}}
                                                    </h6>
                                                </div>
                                                <div class="col-sm-12 p-0">
                                                    <weaccess-table [tableColumns]="jobTableColumns"
                                                        [tableData]="jobTableData"></weaccess-table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- System Access Tab content -->
                                <div *ngSwitchCase="'systemAccess'">
                                    <div class="detail-tab-content-container">
                                        <div class="detail-tab-content-wrap">
                                            <weaccess-info-card [showUpdateBtn]="employeeDetails?.showUpdateButton"
                                                [showReqName]="employeeDetails?.showRequesterName"
                                                [requesterShortName]="employeeDetails?.reqShortName"
                                                [requesterFullName]="employeeDetails?.reqFullName">
                                            </weaccess-info-card>

                                            <div class="row m-0">
                                                <div class="col-sm-12 p-0">
                                                    <weaccess-access-table [tableColumns]="systemAccessTableColumns"
                                                        [tableData]="systemAccessTableData"></weaccess-access-table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </tab>
                    </tabset>
                </div>
            </div>
        </div>
    </div>
</div>